import { render, staticRenderFns } from "./BaseBoxView.vue.html?vue&type=template&id=af535cb0&scoped=true&"
import script from "./BaseBoxView.component.js?vue&type=script&lang=vueJs&"
export * from "./BaseBoxView.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BaseBoxView.scoped.scss?vue&type=style&index=0&id=af535cb0&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af535cb0",
  null
  
)

export default component.exports